module.exports = __webpack_public_path__ + "static/media/gim2.956018ee.jpg";